<template>
  <div class="app-main__inner">
      <div class="app-page-title">
          <div class="page-title-wrapper">
              <div class="page-title-heading">
                  <div class="page-title-icon">
                      <i class="pe-7s-note icon-gradient bg-mean-fruit"></i>
                  </div>
                  <div>Update Profile</div>
              </div>
          </div>
      </div>
      <ul class="body-tabs body-tabs-layout tabs-animated body-tabs-animated nav">
          <li class="nav-item">
              <a class="nav-link" :class="{active:step==1}" @click="step=1" >
                  <span>Profile</span>
              </a>
          </li>
          <li class="nav-item">
              <a class="nav-link" :class="{active:step==2}" @click="step=2">
                  <span>Information</span>
              </a>
          </li>
          <li class="nav-item">
              <a class="nav-link" :class="{active:step==3}" @click="step=3">
                  <span>Additional</span>
              </a>
          </li>
          <li class="nav-item">
              <a class="nav-link" :class="{active:step==4}" @click="step=4">
                  <span>Resume</span>
              </a>
          </li>
          <li class="nav-item">
              <a class="nav-link" :class="{active:step==5}" @click="step=5">
                  <span>Images</span>
              </a>
          </li>
      </ul>
      <FormProfile1 :firstLoad="firstLoad" :talentData="talentData" v-if="step==1"/>
      <FormProfile2 :firstLoad="firstLoad" :talentData="talentData" v-if="step==2"/>
      <FormProfile3 :firstLoad="firstLoad" :talentData="talentData" v-if="step==3"/>
  </div>
</template>

<script>
import FormProfile1 from './FormProfile1.vue'
import FormProfile2 from './FormProfile2.vue'
import FormProfile3 from './FormProfile3.vue'

export default {
  name: 'UpdateProfile',
  components:{ FormProfile1, FormProfile2, FormProfile3 },
  props:{
    firstLoad: Object,
    talentData: Object,
    resumes: Array,
    images: Array,
  },
  data(){
    return {
      step: 1,
    }
  },
}
</script>
